export default {
  token: ({ auth }) => auth.token || undefined
}